import TrebbleSwitch from "../../../../common/TrebbleSwitch";
import TrebbleCard from "../../../../common/TrebbleCard";
import { Template } from "../../VideoEditor";
import { IconDropdown } from '../LayoutConfig/IconDropdown';
import { SquareBorderIcon, SmoothBorderIcon, RoundedBorderIcon } from './BorderRadiusIcons';
import { NoBorderIcon, ShadowIcon, DarkBorderIcon, LightBorderIcon, Border3DLeftIcon, Border3DRightIcon } from './BorderStyleIcons';
import { FieldContainer } from '../CaptionConfig/FieldContainer';
import { IconSelectorCompact } from '../LayoutConfig/IconSelectorCompact';
import ti18n from 'i18n!nls/ClipCreatori18n';

// Extend Window interface if not already done globally
declare global {
    interface Window {
      getI18n: (i18nData: any, key: string, options?: any) => string;
    }
  }

const BORDER_STYLES = Object.freeze({
    NO_BORDER: {
        value: "no_border",
        label: window.getI18n(ti18n, "BORDER_STYLE_NONE"),
        icon: <NoBorderIcon />
    },
    SHADOW: {
        value: "shadow",
        label: window.getI18n(ti18n, "BORDER_STYLE_SHADOW"),
        icon: <ShadowIcon />
    },
    DARK_BORDER: {
        value: "dark_border",
        label: window.getI18n(ti18n, "BORDER_STYLE_DARK"),
        icon: <DarkBorderIcon />
    },
    LIGHT_BORDER: {
        value: "light_border",
        label: window.getI18n(ti18n, "BORDER_STYLE_LIGHT"),
        icon: <LightBorderIcon />
    },
    BORDER_WITH_3D_LEFT: {
        value: "border_with_3d_left",
        label: window.getI18n(ti18n, "BORDER_STYLE_3D_LEFT"),
        icon: <Border3DLeftIcon />
    },
    BORDER_WITH_3D_RIGHT: {
        value: "border_with_3d_right",
        label: window.getI18n(ti18n, "BORDER_STYLE_3D_RIGHT"),
        icon: <Border3DRightIcon />
    },
});

const BORDER_CORNER_RADIUS = Object.freeze({
    SQUARE: {
        value: "0",
        label: window.getI18n(ti18n, "BORDER_RADIUS_SQUARE"),
        icon: <SquareBorderIcon />
    },
    SMOOTH: {
        value: "30",
        label: window.getI18n(ti18n, "BORDER_RADIUS_SMOOTH"),
        icon: <SmoothBorderIcon />
    },
    ROUNDED: {
        value: "50",
        label: window.getI18n(ti18n, "BORDER_RADIUS_ROUNDED"),
        icon: <RoundedBorderIcon />
    },
});

export const FrameComponent = ({ selectedTemplate, setSelectedTemplate }: { selectedTemplate: Template, setSelectedTemplate: (template: Template) => void }) => {
    return (
        <div className="flex flex-col h-full">
            {/* Frame Settings */}
            <TrebbleCard size="small" title={window.getI18n(ti18n, "FRAME_SETTINGS_TITLE")} className="mt-2">
                <div className="flex flex-col">
                    <FieldContainer 
                        label={window.getI18n(ti18n, "SPACING_LABEL")} 
                        direction="row"
                    >
                        <TrebbleSwitch
                            size="small"
                            checked={selectedTemplate.videoConfig.padding}
                            onChange={(checked: boolean) => setSelectedTemplate({ ...selectedTemplate, videoConfig: { ...selectedTemplate.videoConfig, padding: checked } })}
                        />
                    </FieldContainer>

                    <FieldContainer label={window.getI18n(ti18n, "BORDER_RADIUS_LABEL")}>
                        <IconDropdown
                            className="w-full"
                            options={Object.values(BORDER_CORNER_RADIUS)}
                            value={selectedTemplate.videoConfig.borderRadius.toString()}
                            onChange={(value) => setSelectedTemplate({ 
                                ...selectedTemplate, 
                                videoConfig: { 
                                    ...selectedTemplate.videoConfig, 
                                    borderRadius: parseInt(value as string) 
                                } 
                            })}
                        />
                    </FieldContainer>

                    <FieldContainer label={window.getI18n(ti18n, "BORDER_STYLE_LABEL")}>
                        <IconSelectorCompact
                            value={selectedTemplate.videoConfig.borderStyle || BORDER_STYLES.NO_BORDER.value}
                            onChange={(value) => setSelectedTemplate({ 
                                ...selectedTemplate, 
                                videoConfig: { 
                                    ...selectedTemplate.videoConfig, 
                                    borderStyle: value,
                                    border: value !== BORDER_STYLES.NO_BORDER.value
                                } 
                            })}
                            options={Object.values(BORDER_STYLES)}
                            layout="grid"
                            gridCols={2}
                        />
                    </FieldContainer>
                </div>
            </TrebbleCard>
        </div>
    );
};